import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { MultiBranchNodeData } from '../../multi-node-branch-data';

@Component({
  selector: 'automata-multi-branch-node-content',
  templateUrl: './multi-branch-node-content.component.html',
  styleUrls: ['./multi-branch-node-content.component.scss'],
  imports: [CommonModule, TranslateModule, GalaxyPipesModule],
})
export class MultiBranchNodeContentComponent {
  @Input() branchData: MultiBranchNodeData[];
}
